import React from 'react';
import Modal from 'src/components/modal/Modal';
import DivisionForm from './DivisionForm';
import { DivisionWithTagsDTO } from '@erp/shared-types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  division?: DivisionWithTagsDTO; // If provided, modal is in edit mode
  onSuccess?: () => void;
}

const DivisionModal: React.FC<Props> = ({
  isOpen,
  onClose,
  division,
  onSuccess,
}) => {
  const isEditMode = !!division;

  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCloseButton={{
        text: 'Cancel',
        onClick: onClose,
      }}
      title={isEditMode ? 'Edit Division' : 'Create Division'}
      maxWidth="md"
      hideActions={true}
    >
      <DivisionForm
        division={division}
        onSuccess={handleSuccess}
        onCancel={onClose}
        showCancelButton={true}
      />
    </Modal>
  );
};

export default DivisionModal;
